// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.whatsnew {
  --wn-grad-start: #227ebd;
  --wn-grad-end: #5aa7dc;
  --wn-surface: #ffffff;
  --wn-surface-soft: #fbfdff;
  --wn-text-strong: #334155;
  --wn-text-main: #475569;
  --wn-text-muted: #94a3b8;
  --wn-border: #e2e8f0;
  --wn-shadow: none;
  --wn-shadow-hover: 0 4px 12px rgba(15, 23, 42, 0.06);
  --wn-shadow-lg: 0 0 0 3px rgba(34, 126, 189, 0.16);
  --wn-radius: 10px;
  --wn-gap: 8px;
  --wn-img-h: 72px;
  --wn-pad-y: 12px;
  --wn-pad-x: 14px;
  --wn-title-fs: 15px;
  --wn-kicker-fs: 12px;
  --wn-badge-w: 72px;
  --wn-badge-h: 26px;

  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
}

.whatsnew-title {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.whatsnew-titleIcon {
  width: 22px;
  height: 22px;
  display: inline-grid;
  place-items: center;
  border-radius: 999px;
  background: rgba(34, 126, 189, 0.1);
  color: #227ebd;
  border: 1px solid rgba(34, 126, 189, 0.12);
  flex: 0 0 22px;
}

.whatsnew-titleIcon svg {
  stroke: currentColor;
  fill: none;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* ---------- Compact variant ---------- */
.whatsnew.wn-compact {
  --wn-img-h: 0px;
  --wn-pad-y: 8px;
  --wn-pad-x: 12px;
  --wn-title-fs: 14px;
  --wn-kicker-fs: 11px;
  --wn-badge-w: 56px;
  --wn-badge-h: 24px;
}

.whatsnew.wn-compact .wn-media,
.whatsnew.wn-compact .wn-overlay,
.whatsnew.wn-compact .wn-img,
.whatsnew.wn-compact .wn-burst {
  display: none;
}

.whatsnew.wn-compact .wn-card {
  min-height: unset;
}

.whatsnew.wn-compact .wn-card-title {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  overflow-wrap: anywhere;
  word-break: normal;
}

.whatsnew.wn-compact .wn-card-body {
  padding: 12px 76px 12px 12px;
}

.whatsnew.wn-compact .wn-badge {
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
}

/* ---------- Grid ---------- */
.wn-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: var(--wn-gap);
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
}

/* ---------- Card ---------- */
.wn-card {
  position: relative;
  display: block;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 1px solid var(--wn-border);
  border-radius: var(--wn-radius);
  appearance: none;
  -webkit-appearance: none;
  text-align: left;
  cursor: pointer;
  overflow: hidden;
  box-sizing: border-box;
  background: #ffffff;
  color: var(--wn-text-strong);
  box-shadow: var(--wn-shadow);
  transition: box-shadow 0.16s ease, border-color 0.16s ease, background 0.16s ease;
}

.wn-card::before {
  content: none;
}

.wn-card::after {
  content: none;
}

.wn-card:hover {
  box-shadow: var(--wn-shadow-hover);
  border-color: rgba(34, 126, 189, 0.3);
  background: #f8fbfe;
}

.wn-card:active {
  background: #f1f7fb;
}

.wn-card:focus-visible {
  outline: none;
  border-color: #227ebd;
  box-shadow: var(--wn-shadow-lg);
}

.wn-media {
  height: var(--wn-img-h);
  background-size: cover;
  background-position: center;
  opacity: 0.2;
}

.wn-overlay,
.wn-burst {
  display: none;
}

.wn-card-body {
  padding: calc(var(--wn-pad-y) + var(--wn-badge-h) + 6px) calc(var(--wn-pad-x) + var(--wn-badge-w) + 6px)
    calc(var(--wn-pad-y) + 2px) var(--wn-pad-x);
  position: relative;
  z-index: 1;
  min-width: 0;
}

.wn-card-title {
  margin: 0;
  font-size: var(--wn-title-fs);
  line-height: 1.3;
  font-weight: 700;
  color: var(--wn-text-strong) !important;
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.wn-card-kicker {
  margin: 4px 0 0;
  font-size: var(--wn-kicker-fs);
  font-weight: 500;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  max-width: 100%;
}

.wn-cardTitleRow {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.wn-cardIcon {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  display: grid;
  place-items: center;
  border-radius: 999px;
  background: #eef6fb;
  color: #227ebd;
  border: 1px solid rgba(34, 126, 189, 0.14);
}

.wn-cardIcon svg {
  width: 16px;
  height: 16px;
  stroke: currentColor;
  fill: none;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

/* ---------- Badge ---------- */
.wn-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 3;
  pointer-events: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: var(--wn-badge-w);
  height: var(--wn-badge-h);
  padding: 0 10px;
  border-radius: 999px;
  line-height: 1;
  font-weight: 700;
  font-size: 10px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff;
  box-shadow: none;
}

.wn-badge[data-badge='new'] {
  background: rgba(21, 128, 61, 0.12);
  color: #15803d;
  border: 1px solid rgba(21, 128, 61, 0.2);
  box-shadow: none;
}

.wn-badge[data-badge='update'] {
  background: rgba(29, 78, 216, 0.1);
  color: #1d4ed8;
  border: 1px solid rgba(29, 78, 216, 0.18);
  box-shadow: none;
}

.wn-badge[data-badge='beta'] {
  background: rgba(124, 58, 237, 0.1);
  color: #7c3aed;
  border: 1px solid rgba(124, 58, 237, 0.18);
  box-shadow: none;
}

.wn-badge[data-badge='wow'] {
  background: rgba(194, 65, 12, 0.1);
  color: #c2410c;
  border: 1px solid rgba(194, 65, 12, 0.18);
  box-shadow: none;
}

.wn-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  min-width: 0;
}

.wn-loading,
.wn-error,
.wn-empty {
  padding: 8px 0;
  color: #94a3b8;
  font-size: 13px;
}

/* =========================================================
   Modal
   ========================================================= */

.wn-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(3px);
  display: grid;
  place-items: center;
  z-index: 9999;
}

.wn-modal {
  width: min(680px, 92vw);
  max-height: 82vh;
  background: #fff;
  color: #1f2937;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 32px 80px rgba(15, 23, 42, 0.2), 0 8px 24px rgba(15, 23, 42, 0.1);
}

.wn-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: linear-gradient(180deg, #ffffff, #f8fbff);
  border-bottom: 1px solid rgba(15, 23, 42, 0.08);
}

.wn-modal-header h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 800;
  color: #334155;
  letter-spacing: 0.1px;
}

.wn-close {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  line-height: 1;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 8px;
  background: rgba(15, 23, 42, 0.03);
  cursor: pointer;
  color: #94a3b8;
  transition: background 0.14s ease, color 0.14s ease, border-color 0.14s ease;
}

.wn-close:hover {
  background: rgba(239, 68, 68, 0.07);
  color: #b91c1c;
  border-color: rgba(239, 68, 68, 0.14);
}

.wn-modal-content {
  padding: 20px;
  overflow: auto;
  font-size: 14px;
  line-height: 1.65;
  color: #475569;
}

.wn-modal-content p {
  margin: 0 0 12px;
}

.wn-modal-content ul {
  margin: 0 0 12px 18px;
}

.wn-modal-content li {
  margin-bottom: 6px;
}

.wn-modal-content strong,
.wn-modal-content b {
  color: #0f172a;
}

.wn-modal .wn-modal-content a {
  color: #227ebd;
  font-weight: 700;
  text-decoration: underline;
}

.wn-modal-footer {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  padding: 14px 20px;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  flex-wrap: wrap;
  background: #fafbfc;
}

/* =========================================================
   Modal Buttons
   ========================================================= */

.wn-cta {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 10px 20px;
  border: none;
  border-radius: 10px;
  color: #fff;
  background: #227ebd;
  box-shadow: 0 4px 12px rgba(34, 126, 189, 0.25);
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.16s ease, box-shadow 0.16s ease;
}

.wn-cta:hover {
  background: #1a6da3;
  box-shadow: 0 6px 16px rgba(34, 126, 189, 0.3);
  text-decoration: none;
  color: #fff;
}

.wn-cta:active {
  background: #155d8c;
}

.wn-cta:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.25);
}

.wn-secondary {
  padding: 10px 16px;
  border-radius: 10px;
  border: 1px solid rgba(15, 23, 42, 0.1);
  background: rgba(15, 23, 42, 0.04);
  color: #475569;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.16s ease, color 0.16s ease, border-color 0.16s ease;
}

.wn-secondary:hover {
  background: rgba(15, 23, 42, 0.08);
  color: #0f172a;
  border-color: rgba(15, 23, 42, 0.16);
}

.wn-secondary:active {
  background: rgba(15, 23, 42, 0.12);
}

/* colour variants — kept for backward compat but toned down */
.wn-cta--teal {
  background: #0891b2;
}
.wn-cta--blue {
  background: #2563eb;
}
.wn-cta--purple {
  background: #7c3aed;
}
.wn-cta--green {
  background: #15803d;
}
.wn-cta--rose {
  background: #e11d48;
}

.wn-secondary--blue {
  background: #2563eb;
  color: #fff;
  border-color: transparent;
}
.wn-secondary--teal {
  background: #0891b2;
  color: #fff;
  border-color: transparent;
}
.wn-secondary--purple {
  background: #7c3aed;
  color: #fff;
  border-color: transparent;
}
.wn-secondary--rose {
  background: #e11d48;
  color: #fff;
  border-color: transparent;
}

/* =========================================================
   Accessibility
   ========================================================= */

@media (prefers-reduced-motion: reduce) {
  .wn-card,
  .wn-cta,
  .wn-secondary {
    transition: none !important;
  }
  .wn-card:hover {
    transform: none !important;
  }
}

@media (prefers-color-scheme: dark) {
  .wn-modal {
    background: #171717;
    color: #eaeaea;
    border-color: rgba(255, 255, 255, 0.08);
  }
  .wn-modal-header {
    background: #1e1e1e;
    border-color: rgba(255, 255, 255, 0.08);
  }
  .wn-modal-header h3 {
    color: #f8fafc;
  }
  .wn-modal-footer {
    background: #141414;
    border-color: rgba(255, 255, 255, 0.06);
  }
  .wn-modal-content {
    color: #cbd5e1;
  }
  .wn-modal .wn-modal-content a {
    color: #60a5fa;
  }
  .wn-secondary {
    background: rgba(255, 255, 255, 0.06);
    color: #cbd5e1;
    border-color: rgba(255, 255, 255, 0.1);
  }
  .wn-secondary:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #f8fafc;
  }
}

.wn-view-more {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  padding: 8px 14px;
  border-radius: 10px;
  border: 1px solid rgba(34, 126, 189, 0.2);
  background: rgba(34, 126, 189, 0.04);
  color: #227ebd;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.16s ease, border-color 0.16s ease;
}

.wn-view-more:hover {
  background: rgba(34, 126, 189, 0.08);
  border-color: rgba(34, 126, 189, 0.3);
}

.wn-modal--all {
  max-height: 70vh;
}

.wn-all-list {
  display: flex;
  flex-direction: column;
  padding: 8px;
  overflow-y: auto;
  gap: 4px;
}

.wn-all-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  border-radius: 10px;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  transition: background 0.14s ease;
}

.wn-all-item:hover {
  background: rgba(34, 126, 189, 0.06);
}

.wn-all-item-icon {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  display: grid;
  place-items: center;
  border-radius: 999px;
  background: rgba(34, 126, 189, 0.1);
  color: #227ebd;
  border: 1px solid rgba(34, 126, 189, 0.12);
}

.wn-all-item-icon svg {
  width: 16px;
  height: 16px;
  stroke: currentColor;
  fill: none;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.wn-all-item-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: 2px;
}

.wn-all-item-title {
  font-size: 14px;
  font-weight: 700;
  color: #334155;
  line-height: 1.2;
}

.wn-all-item-kicker {
  font-size: 12px;
  color: #94a3b8;
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/Dashboard/WhatsNewWidget.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;EACjB,oDAAoD;EACpD,kDAAkD;EAClD,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;;EAElB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,kCAAkC;EAClC,+BAA+B;EAC/B,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,4BAA4B;EAC5B,iFAAiF;AACnF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE;+CAC6C;EAC7C,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;AACd;;AAEA;;;EAGE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;;8DAE8D;;AAE9D;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,+EAA+E;AACjF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;EACrD,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,wCAAwC;EACxC,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,cAAc;EACd,4EAA4E;AAC9E;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;EACf,mBAAmB;AACrB;;AAEA;;8DAE8D;;AAE9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;EAC9C,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;8DAE8D;;AAE9D;EACE;;;IAGE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,cAAc;IACd,uCAAuC;EACzC;EACA;IACE,mBAAmB;IACnB,uCAAuC;EACzC;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,uCAAuC;EACzC;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,qCAAqC;IACrC,cAAc;IACd,sCAAsC;EACxC;EACA;IACE,oCAAoC;IACpC,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;EACP,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":[".whatsnew {\n  --wn-grad-start: #227ebd;\n  --wn-grad-end: #5aa7dc;\n  --wn-surface: #ffffff;\n  --wn-surface-soft: #fbfdff;\n  --wn-text-strong: #334155;\n  --wn-text-main: #475569;\n  --wn-text-muted: #94a3b8;\n  --wn-border: #e2e8f0;\n  --wn-shadow: none;\n  --wn-shadow-hover: 0 4px 12px rgba(15, 23, 42, 0.06);\n  --wn-shadow-lg: 0 0 0 3px rgba(34, 126, 189, 0.16);\n  --wn-radius: 10px;\n  --wn-gap: 8px;\n  --wn-img-h: 72px;\n  --wn-pad-y: 12px;\n  --wn-pad-x: 14px;\n  --wn-title-fs: 15px;\n  --wn-kicker-fs: 12px;\n  --wn-badge-w: 72px;\n  --wn-badge-h: 26px;\n\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.whatsnew-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.whatsnew-titleIcon {\n  width: 22px;\n  height: 22px;\n  display: inline-grid;\n  place-items: center;\n  border-radius: 999px;\n  background: rgba(34, 126, 189, 0.1);\n  color: #227ebd;\n  border: 1px solid rgba(34, 126, 189, 0.12);\n  flex: 0 0 22px;\n}\n\n.whatsnew-titleIcon svg {\n  stroke: currentColor;\n  fill: none;\n  stroke-width: 1.9;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n/* ---------- Compact variant ---------- */\n.whatsnew.wn-compact {\n  --wn-img-h: 0px;\n  --wn-pad-y: 8px;\n  --wn-pad-x: 12px;\n  --wn-title-fs: 14px;\n  --wn-kicker-fs: 11px;\n  --wn-badge-w: 56px;\n  --wn-badge-h: 24px;\n}\n\n.whatsnew.wn-compact .wn-media,\n.whatsnew.wn-compact .wn-overlay,\n.whatsnew.wn-compact .wn-img,\n.whatsnew.wn-compact .wn-burst {\n  display: none;\n}\n\n.whatsnew.wn-compact .wn-card {\n  min-height: unset;\n}\n\n.whatsnew.wn-compact .wn-card-title {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  overflow: hidden;\n  overflow-wrap: anywhere;\n  word-break: normal;\n}\n\n.whatsnew.wn-compact .wn-card-body {\n  padding: 12px 76px 12px 12px;\n}\n\n.whatsnew.wn-compact .wn-badge {\n  top: 50%;\n  right: 12px;\n  transform: translateY(-50%);\n}\n\n/* ---------- Grid ---------- */\n.wn-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: var(--wn-gap);\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n}\n\n/* ---------- Card ---------- */\n.wn-card {\n  position: relative;\n  display: block;\n  width: 100%;\n  min-width: 0;\n  margin: 0;\n  padding: 0;\n  border: 1px solid var(--wn-border);\n  border-radius: var(--wn-radius);\n  appearance: none;\n  -webkit-appearance: none;\n  text-align: left;\n  cursor: pointer;\n  overflow: hidden;\n  box-sizing: border-box;\n  background: #ffffff;\n  color: var(--wn-text-strong);\n  box-shadow: var(--wn-shadow);\n  transition: box-shadow 0.16s ease, border-color 0.16s ease, background 0.16s ease;\n}\n\n.wn-card::before {\n  content: none;\n}\n\n.wn-card::after {\n  content: none;\n}\n\n.wn-card:hover {\n  box-shadow: var(--wn-shadow-hover);\n  border-color: rgba(34, 126, 189, 0.3);\n  background: #f8fbfe;\n}\n\n.wn-card:active {\n  background: #f1f7fb;\n}\n\n.wn-card:focus-visible {\n  outline: none;\n  border-color: #227ebd;\n  box-shadow: var(--wn-shadow-lg);\n}\n\n.wn-media {\n  height: var(--wn-img-h);\n  background-size: cover;\n  background-position: center;\n  opacity: 0.2;\n}\n\n.wn-overlay,\n.wn-burst {\n  display: none;\n}\n\n.wn-card-body {\n  padding: calc(var(--wn-pad-y) + var(--wn-badge-h) + 6px) calc(var(--wn-pad-x) + var(--wn-badge-w) + 6px)\n    calc(var(--wn-pad-y) + 2px) var(--wn-pad-x);\n  position: relative;\n  z-index: 1;\n  min-width: 0;\n}\n\n.wn-card-title {\n  margin: 0;\n  font-size: var(--wn-title-fs);\n  line-height: 1.3;\n  font-weight: 700;\n  color: var(--wn-text-strong) !important;\n  white-space: normal !important;\n  overflow-wrap: anywhere;\n  word-break: normal;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n}\n\n.wn-card-kicker {\n  margin: 4px 0 0;\n  font-size: var(--wn-kicker-fs);\n  font-weight: 500;\n  color: #64748b;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.wn-cardTitleRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.wn-cardIcon {\n  width: 32px;\n  height: 32px;\n  flex: 0 0 32px;\n  display: grid;\n  place-items: center;\n  border-radius: 999px;\n  background: #eef6fb;\n  color: #227ebd;\n  border: 1px solid rgba(34, 126, 189, 0.14);\n}\n\n.wn-cardIcon svg {\n  width: 16px;\n  height: 16px;\n  stroke: currentColor;\n  fill: none;\n  stroke-width: 1.9;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n/* ---------- Badge ---------- */\n.wn-badge {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 3;\n  pointer-events: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: var(--wn-badge-w);\n  height: var(--wn-badge-h);\n  padding: 0 10px;\n  border-radius: 999px;\n  line-height: 1;\n  font-weight: 700;\n  font-size: 10px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #fff;\n  box-shadow: none;\n}\n\n.wn-badge[data-badge='new'] {\n  background: rgba(21, 128, 61, 0.12);\n  color: #15803d;\n  border: 1px solid rgba(21, 128, 61, 0.2);\n  box-shadow: none;\n}\n\n.wn-badge[data-badge='update'] {\n  background: rgba(29, 78, 216, 0.1);\n  color: #1d4ed8;\n  border: 1px solid rgba(29, 78, 216, 0.18);\n  box-shadow: none;\n}\n\n.wn-badge[data-badge='beta'] {\n  background: rgba(124, 58, 237, 0.1);\n  color: #7c3aed;\n  border: 1px solid rgba(124, 58, 237, 0.18);\n  box-shadow: none;\n}\n\n.wn-badge[data-badge='wow'] {\n  background: rgba(194, 65, 12, 0.1);\n  color: #c2410c;\n  border: 1px solid rgba(194, 65, 12, 0.18);\n  box-shadow: none;\n}\n\n.wn-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n  min-width: 0;\n}\n\n.wn-loading,\n.wn-error,\n.wn-empty {\n  padding: 8px 0;\n  color: #94a3b8;\n  font-size: 13px;\n}\n\n/* =========================================================\n   Modal\n   ========================================================= */\n\n.wn-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.5);\n  backdrop-filter: blur(3px);\n  display: grid;\n  place-items: center;\n  z-index: 9999;\n}\n\n.wn-modal {\n  width: min(680px, 92vw);\n  max-height: 82vh;\n  background: #fff;\n  color: #1f2937;\n  border-radius: 16px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  box-shadow: 0 32px 80px rgba(15, 23, 42, 0.2), 0 8px 24px rgba(15, 23, 42, 0.1);\n}\n\n.wn-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  background: linear-gradient(180deg, #ffffff, #f8fbff);\n  border-bottom: 1px solid rgba(15, 23, 42, 0.08);\n}\n\n.wn-modal-header h3 {\n  margin: 0;\n  font-size: 17px;\n  font-weight: 800;\n  color: #334155;\n  letter-spacing: 0.1px;\n}\n\n.wn-close {\n  width: 30px;\n  height: 30px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  line-height: 1;\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  border-radius: 8px;\n  background: rgba(15, 23, 42, 0.03);\n  cursor: pointer;\n  color: #94a3b8;\n  transition: background 0.14s ease, color 0.14s ease, border-color 0.14s ease;\n}\n\n.wn-close:hover {\n  background: rgba(239, 68, 68, 0.07);\n  color: #b91c1c;\n  border-color: rgba(239, 68, 68, 0.14);\n}\n\n.wn-modal-content {\n  padding: 20px;\n  overflow: auto;\n  font-size: 14px;\n  line-height: 1.65;\n  color: #475569;\n}\n\n.wn-modal-content p {\n  margin: 0 0 12px;\n}\n\n.wn-modal-content ul {\n  margin: 0 0 12px 18px;\n}\n\n.wn-modal-content li {\n  margin-bottom: 6px;\n}\n\n.wn-modal-content strong,\n.wn-modal-content b {\n  color: #0f172a;\n}\n\n.wn-modal .wn-modal-content a {\n  color: #227ebd;\n  font-weight: 700;\n  text-decoration: underline;\n}\n\n.wn-modal-footer {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  padding: 14px 20px;\n  border-top: 1px solid rgba(15, 23, 42, 0.06);\n  flex-wrap: wrap;\n  background: #fafbfc;\n}\n\n/* =========================================================\n   Modal Buttons\n   ========================================================= */\n\n.wn-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 10px;\n  color: #fff;\n  background: #227ebd;\n  box-shadow: 0 4px 12px rgba(34, 126, 189, 0.25);\n  font-weight: 700;\n  font-size: 14px;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background 0.16s ease, box-shadow 0.16s ease;\n}\n\n.wn-cta:hover {\n  background: #1a6da3;\n  box-shadow: 0 6px 16px rgba(34, 126, 189, 0.3);\n  text-decoration: none;\n  color: #fff;\n}\n\n.wn-cta:active {\n  background: #155d8c;\n}\n\n.wn-cta:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.25);\n}\n\n.wn-secondary {\n  padding: 10px 16px;\n  border-radius: 10px;\n  border: 1px solid rgba(15, 23, 42, 0.1);\n  background: rgba(15, 23, 42, 0.04);\n  color: #475569;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.16s ease, color 0.16s ease, border-color 0.16s ease;\n}\n\n.wn-secondary:hover {\n  background: rgba(15, 23, 42, 0.08);\n  color: #0f172a;\n  border-color: rgba(15, 23, 42, 0.16);\n}\n\n.wn-secondary:active {\n  background: rgba(15, 23, 42, 0.12);\n}\n\n/* colour variants — kept for backward compat but toned down */\n.wn-cta--teal {\n  background: #0891b2;\n}\n.wn-cta--blue {\n  background: #2563eb;\n}\n.wn-cta--purple {\n  background: #7c3aed;\n}\n.wn-cta--green {\n  background: #15803d;\n}\n.wn-cta--rose {\n  background: #e11d48;\n}\n\n.wn-secondary--blue {\n  background: #2563eb;\n  color: #fff;\n  border-color: transparent;\n}\n.wn-secondary--teal {\n  background: #0891b2;\n  color: #fff;\n  border-color: transparent;\n}\n.wn-secondary--purple {\n  background: #7c3aed;\n  color: #fff;\n  border-color: transparent;\n}\n.wn-secondary--rose {\n  background: #e11d48;\n  color: #fff;\n  border-color: transparent;\n}\n\n/* =========================================================\n   Accessibility\n   ========================================================= */\n\n@media (prefers-reduced-motion: reduce) {\n  .wn-card,\n  .wn-cta,\n  .wn-secondary {\n    transition: none !important;\n  }\n  .wn-card:hover {\n    transform: none !important;\n  }\n}\n\n@media (prefers-color-scheme: dark) {\n  .wn-modal {\n    background: #171717;\n    color: #eaeaea;\n    border-color: rgba(255, 255, 255, 0.08);\n  }\n  .wn-modal-header {\n    background: #1e1e1e;\n    border-color: rgba(255, 255, 255, 0.08);\n  }\n  .wn-modal-header h3 {\n    color: #f8fafc;\n  }\n  .wn-modal-footer {\n    background: #141414;\n    border-color: rgba(255, 255, 255, 0.06);\n  }\n  .wn-modal-content {\n    color: #cbd5e1;\n  }\n  .wn-modal .wn-modal-content a {\n    color: #60a5fa;\n  }\n  .wn-secondary {\n    background: rgba(255, 255, 255, 0.06);\n    color: #cbd5e1;\n    border-color: rgba(255, 255, 255, 0.1);\n  }\n  .wn-secondary:hover {\n    background: rgba(255, 255, 255, 0.1);\n    color: #f8fafc;\n  }\n}\n\n.wn-view-more {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin-top: 10px;\n  padding: 8px 14px;\n  border-radius: 10px;\n  border: 1px solid rgba(34, 126, 189, 0.2);\n  background: rgba(34, 126, 189, 0.04);\n  color: #227ebd;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.16s ease, border-color 0.16s ease;\n}\n\n.wn-view-more:hover {\n  background: rgba(34, 126, 189, 0.08);\n  border-color: rgba(34, 126, 189, 0.3);\n}\n\n.wn-modal--all {\n  max-height: 70vh;\n}\n\n.wn-all-list {\n  display: flex;\n  flex-direction: column;\n  padding: 8px;\n  overflow-y: auto;\n  gap: 4px;\n}\n\n.wn-all-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: none;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.14s ease;\n}\n\n.wn-all-item:hover {\n  background: rgba(34, 126, 189, 0.06);\n}\n\n.wn-all-item-icon {\n  width: 32px;\n  height: 32px;\n  flex: 0 0 32px;\n  display: grid;\n  place-items: center;\n  border-radius: 999px;\n  background: rgba(34, 126, 189, 0.1);\n  color: #227ebd;\n  border: 1px solid rgba(34, 126, 189, 0.12);\n}\n\n.wn-all-item-icon svg {\n  width: 16px;\n  height: 16px;\n  stroke: currentColor;\n  fill: none;\n  stroke-width: 1.9;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.wn-all-item-body {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n  gap: 2px;\n}\n\n.wn-all-item-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #334155;\n  line-height: 1.2;\n}\n\n.wn-all-item-kicker {\n  font-size: 12px;\n  color: #94a3b8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
